import dayjs from 'dayjs';
// Recursively trim all string values in an object, array, or string
export function trimFormValues(obj) {
  if (typeof obj === 'string') {
    return obj.trim();
  } else if (Array.isArray(obj)) {
    return obj.map(trimFormValues);
  } else if (typeof obj === 'object' && obj !== null) {
    // Don't trim Dayjs objects
    if (dayjs.isDayjs(obj)) {
      return obj;
    }
    const trimmed = {};
    for (const key in obj) {
      trimmed[key] = trimFormValues(obj[key]);
    }
    return trimmed;
  }
  return obj;
} 